<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                            :loading="dataset.loading" v-if="page.isNew">Salvar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataset.loading" v-if="!page.isNew">Atualizar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/feriados">Voltar</v-btn>
                    </div>
                    <!-- <div class="button-group">
                        <v-btn type="button" elevation="0" color="primary" @click="add"
                            :loading="dataset.loading">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/passageiros">Voltar</v-btn>
                    </div> -->
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field v-model="dataset.data.name" label="Nome do Feriado"
                                                :rules="[$rules.required]" outlined dense
                                                hide-details="auto"></v-text-field>
                                        </v-col>
                                        <!-- <v-col cols="12" md="6">
                                            <v-menu v-model="dateMenu" :close-on-content-click="false" :nudge-right="40"
                                        transition="scale-transition" offset-y min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="formattedDate" label="Data do Feriado"
                                                :rules="[rules.required, rules.dateValid]"
                                                prepend-inner-icon="mdi-calendar" readonly outlined dense
                                                hide-details="auto" v-bind="attrs" v-on="on"></v-text-field>
                                        </template>
<v-date-picker v-model="holiday.date" @input="dateMenu = false" locale="pt-BR" no-title></v-date-picker>
</v-col> -->
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-date-picker v-model="dataset.data.dates" multiple locale="pt-BR"
                                                no-title></v-date-picker>
                                        </v-col>
                                        <v-col>
                                            <v-card-text>
                                                <span><strong>Datas selecionadas:</strong></span>
                                                </br>
                                                </br>
                                                <template v-if="dataset.data.dates.length">
                                                    <v-row dense v-for="(item, index) in dataset.data.dates">
                                                        <v-col>
                                                            <strong>- {{ item | defaultDate }}</strong>
                                                        </v-col>
                                                        <v-col>
                                                            <v-tooltip bottom>
                                                                <template #activator="{ on }">
                                                                    <v-icon v-on="on" @click="deleteDate(index)"
                                                                        size="large">
                                                                        mdi-delete
                                                                    </v-icon>
                                                                </template>
                                                                <span>Remover data</span>
                                                            </v-tooltip>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <v-row v-else>
                                                    <v-col>
                                                        <span>Nenhuma data selecionada</span>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    name: 'HolidaysDetails',
    data: () => ({
        page: {
            title: "",
            isNew: false
        },
        dataset: {
            data: { dates: [] },
            breadcrumbItems: [],
            loading: false,
        },
        dataForm: {
            validForm: true,
        },
        // dateMenu: false,
        // rules: {
        //     required: value => !!value || 'Campo obrigatório.',
        //     dateValid: value => {
        //         if (!value) return true;
        //         const pattern = /^\d{2}\/\d{2}\/\d{4}$/;
        //         return pattern.test(value) || 'Formato de data inválido (DD/MM/YYYY).';
        //     },
        // },
    }),
    computed: {
        // formattedDate() {
        //     if (!this.data.date) return '';
        //     if (typeof this.holiday.date === 'string' && this.holiday.date.includes('-')) {
        //         const [year, month, day] = this.holiday.date.split('-');
        //         return `${day}/${month}/${year}`;
        //     }
        //     return '';
        // },
    },

    created() {
        this.loadData()
    },


    methods: {
        goBack() {
            this.$router.replace("/feriados");
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            await this.load();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = this.page.isNew ? "Novo feriado" : "Detalhes do feriado";
        },


        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Listagem de feriados",
                disabled: false,
                to: "/feriados",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.isNew ? "Incluir feriado" : "Detalhes do feriado",
                disabled: true,
                exact: true,
            });
        },

        async load() {
            if (this.page.isNew) return;

            this.dataset.loading = true

            try {
                const result = await axios.get(`/api/v2/holidays/${this.$route.params.id}`);

                this.dataset.data = result.data.content.data

            } catch (error) {
                this.$dialog.notify.error('Ocorreu um erro ao encontrar as informações do feriado, tente novamente!', {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        toggleDate(date) {
            const index = this.dataset.data.dates.indexOf(date)
            if (index === -1) {
                this.dataset.data.dates.push(date)
            } else {
                this.dataset.data.dates.splice(index, 1)
            }
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir o feriado?',
                title: 'Incluir feriado',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post('/api/v2/holidays', payload);

                this.$dialog.notify.info("Feriado salvo com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }

        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar os dados do feriado?',
                title: 'Atualizar feriado',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/v2/holidays/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Feriado atualizado com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        deleteDate(index) {
            this.dataset.data.dates.splice(index, 1)
        },

        buildPayload() {
            return {
                name: this.dataset.data.name,
                dates: this.dataset.data.dates
            }
        }
    }

};
</script>